import { serverType } from "./server-config";

/** HOST */
export let host: string;
export let hostTest: string = 'https://test.mamalaile.com.cn';
export let hostOnline: string = 'https://app.mamalaile.com.cn';
switch (serverType) {
  case 'test': host = hostTest; break;
  case 'online': host = hostOnline; break;
}

/** 请求接口 */
export let api: { [key: string]: string; } = {
  /** 最近20条好评 */
  getEvaluateLast20: "/waitereval/getEvaluateLast20",
  /** 评论id获取评论详情 */
  getEvaluateDetail: "/waitereval/getEvaluateDetail",
  /** 公司动态 */
  getShowWebsiteKnowinfo: "/knowinfo/getShowWebsiteKnowinfo",
  /** 获取urlScheme */
  getUrlScheme: "/common/getUrlScheme",
};

/**
 * 根据serverFlag环境类型设置HOST
 */
switch (serverType) {
  case 'test':
  default:
    host = 'test/mobile';
    break;
  case 'online':
    host = 'online/mobile';
    break;
}

let devEnv = false;
if (location.host != 'test.mamalaile.com.cn'
  && location.host != 'app.mamalaile.com.cn'
  && location.host != 'mamalaile.com'
  && location.host != 'mamalaile.cn'
  && location.host != 'www.mamalaile.com'
  && location.host != 'www.mamalaile.cn') {
  devEnv = true;
}

if (!devEnv) {
  host = `${document.location.protocol}//${window.location.host}/${host.split('/')[1]}`;
} else {
  host = `${document.location.protocol}//${window.location.host}/${host}`;
}

for (let key in api) { api[key] = host + api[key]; }